import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FadeLoader} from 'react-spinners';

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Loading extends Component {
  constructor(props) {
    super(props);

    this.updateLoading = this.updateLoading.bind(this);

    this.state = {
      loading: false
    }
  }

  updateLoading() {
    let loading = (this.props.loading) ? this.props.loading : false;
    this.setState({
      loading: loading
    });
  }

  componentDidMount() {
    // if call render will do this method
    this.updateLoading();
  }
  
  componentDidUpdate (prevProps, prevState, snapshot) {
    // if props change will call this method
    if (prevProps.loading !== this.props.loading) {
      this.updateLoading();
    }    
  }

  render() {
    const { center } = this.props;
    const classCenter = center ? ' center' : '';

    return (
      <div className={'page-loading' +  classCenter}>
        <FadeLoader
          css={override}
          sizeUnit={"px"}
          size={100}
          color={'#123abc'}
          loading={this.state.loading}
        />
      </div>
    )
  }
}

export default connect(
  null,
  { }
)(Loading)